<script setup>
import { computed } from 'vue'
import { getI18n } from '@/plugins/i18n'

import { usePlanningStore } from '@/stores/planning.store'
import { usePortalStore } from '@/stores/portal.store'
import { useChips } from '@/composables/chips'

import ListItem from '@/components/shared/ListItem.vue'

const props = defineProps({
  group: {
    type: Object,
    required: true,
  },
})

const i18n = getI18n()
const planningStore = usePlanningStore()
const portalStore = usePortalStore()
const { getServiceStructureTypeChip } = useChips()

const { STAFF, GROUP } = portalStore.serviceTypeEnum
const avatarIconMap = {
  [STAFF]: 'mdi-account',
  [GROUP]: 'mdi-select-group',
}
const getAvatarIcon = (s) => avatarIconMap[s.type] || 'mdi-camera-outline'

const components = computed(() =>
  (props.group.components || [])
    .map(c => {
      const service = planningStore.getServiceById(c.id)
      return service ? { ...service, quantity: c.quantity } : null
    })
    .filter(Boolean)
)
</script>

<template>
  <div v-if="components.length === 0" class="text-grey-6 text-center q-pa-md">
    {{ i18n.t('common.noData') }}
  </div>
  <q-list v-else>
    <q-item
      v-for="component in components"
      :key="component.id"
      style="padding: 0.5rem 1rem"
    >
      <list-item
        :avatar="component.avatar_file || component.avatar_url"
        :avatar-icon="getAvatarIcon(component)"
        :label="`${component.id} - ${planningStore.getServiceName(component)}`"
        :caption-chips="getServiceStructureTypeChip(component.structure_type)"
        dense
      >
        <template #right>
          <q-avatar color="grey-6" text-color="white" size="sm">
            <span class="text-caption text-weight-bold">{{ component.quantity }}</span>
          </q-avatar>
        </template>
      </list-item>
    </q-item>
  </q-list>
</template>
